import { render, staticRenderFns } from "./FormUploadPdf.vue?vue&type=template&id=053ce166"
import script from "./FormUploadPdf.vue?vue&type=script&lang=js"
export * from "./FormUploadPdf.vue?vue&type=script&lang=js"
import style0 from "./FormUploadPdf.vue?vue&type=style&index=0&id=053ce166&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports